function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectTypeCircleForestryAndWoodlandCreation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.671371,
    y: 0.671371,
    width: 30.8831,
    height: 30.8831,
    rx: 15.4415,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.671371,
    y: 0.671371,
    width: 30.8831,
    height: 30.8831,
    rx: 15.4415,
    stroke: "#5F9375",
    style: {
      stroke: "#5F9375",
      stroke: "color(display-p3 0.3725 0.5765 0.4588)",
      strokeOpacity: 1
    },
    strokeWidth: 1.34274
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3423 13.2381C24.3423 12.2656 23.8494 11.3762 22.9899 10.7979C22.3442 10.3634 21.5757 10.159 20.8011 10.2027C20.5182 8.08048 18.5245 6.43066 16.1149 6.43066C13.7053 6.43066 11.7116 8.08048 11.4287 10.2027C10.6538 10.1589 9.88549 10.3634 9.23984 10.7979C8.38041 11.3762 7.88745 12.2656 7.88745 13.2381C7.88745 14.2053 8.40101 15.1038 9.22642 15.6692C8.53587 16.3973 8.15239 17.3248 8.15239 18.3106C8.15239 20.5471 10.1538 22.3666 12.6139 22.3666C13.68 22.3666 14.6887 22.0268 15.4855 21.4156V25.3893C15.4855 25.7053 15.7673 25.9615 16.1149 25.9615C16.4625 25.9615 16.7443 25.7053 16.7443 25.3893V21.4156C17.5411 22.0268 18.5497 22.3666 19.6159 22.3666C22.076 22.3666 24.0774 20.5471 24.0774 18.3106C24.0774 17.3248 23.6939 16.3974 23.0034 15.6692C23.8288 15.1038 24.3423 14.2053 24.3423 13.2381ZM19.6159 21.2222C18.6345 21.2222 17.7207 20.8212 17.1086 20.1221C17.0157 20.0161 16.8861 19.9457 16.7443 19.9188V16.5453C16.7528 16.5384 16.7616 16.5319 16.7697 16.5244L18.574 14.8841C18.8198 14.6607 18.8198 14.2984 18.574 14.0749C18.3283 13.8515 17.9297 13.8515 17.6839 14.0749L16.7443 14.9291V11.0845C16.7443 10.7685 16.4625 10.5123 16.1149 10.5123C15.7673 10.5123 15.4855 10.7685 15.4855 11.0845V17.1034L13.9374 15.6961C13.6916 15.4726 13.2931 15.4726 13.0473 15.6961C12.8015 15.9195 12.8015 16.2818 13.0473 16.5053L15.3341 18.5842C15.3799 18.6259 15.4311 18.6597 15.4854 18.6858V19.9184C15.3437 19.9453 15.214 20.0161 15.1212 20.1221C14.5091 20.8212 13.5952 21.2222 12.6139 21.2222C10.8479 21.2222 9.41117 19.9161 9.41117 18.3106C9.41117 17.3999 9.86724 16.5584 10.6625 16.002C10.8436 15.8752 10.9349 15.6692 10.901 15.4637C10.8671 15.2582 10.7134 15.0856 10.4993 15.0127C9.69 14.7372 9.14623 14.024 9.14623 13.2381C9.14623 12.6321 9.4533 12.078 9.98876 11.7177C10.5273 11.3553 11.2019 11.249 11.8398 11.4262C12.0306 11.4791 12.2378 11.4468 12.3981 11.3388C12.5585 11.2309 12.6531 11.0603 12.6531 10.8789V10.7221C12.6531 8.98679 14.2061 7.57505 16.1148 7.57505C18.0236 7.57505 19.5766 8.98679 19.5766 10.7221V10.8789C19.5766 11.0603 19.6712 11.2309 19.8316 11.3388C19.9919 11.4468 20.199 11.4791 20.3899 11.4262C21.0277 11.249 21.7025 11.3554 22.2409 11.7177C22.7764 12.078 23.0835 12.6321 23.0835 13.2381C23.0835 14.0241 22.5397 14.7372 21.7304 15.0127C21.5163 15.0856 21.3625 15.2582 21.3287 15.4637C21.2948 15.6692 21.3861 15.8753 21.5672 16.002C22.3625 16.5585 22.8185 17.4 22.8185 18.3106C22.8186 19.9161 21.3818 21.2222 19.6159 21.2222Z",
    fill: "#5F9375",
    style: {
      fill: "#5F9375",
      fill: "color(display-p3 0.3725 0.5765 0.4588)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectTypeCircleForestryAndWoodlandCreation);
export default __webpack_public_path__ + "static/media/project-type-circle-forestry-and-woodland-creation.0ff6441604e09883456eeeaaeab1c130.svg";
export { ForwardRef as ReactComponent };